<section class="content tab-section d-flex">
  <div class="content-block flex-grow-1">
    <div *ngFor="let item of items; let i = index" (mouseover)="onHover($event, i)" (mouseout)="onHoverOut()"
      class="hover-item">
      Hover over item {{item.name}}
    </div>
    <div #hoverDiv
      style="display: none; position: absolute; background-color: yellow; padding: 10px; border: 1px solid black;">
      {{ hoverContent.name }}{{hoverContent.content}}
    </div>

  </div>
</section>